(function () {
  function closeSiblings(root, current) {
    var items = root.querySelectorAll('.wt-faq__item');
    for (var i = 0; i < items.length; i++) {
      if (items[i] !== current && items[i].open) {
        items[i].open = false;
      }
    }
  }

  function bind(root) {
    if (root.dataset.faqBound === 'true') return;
    root.dataset.faqBound = 'true';

    if (root.dataset.faqMultiple === 'true') return;

    root.addEventListener('toggle', function (event) {
      var item = event.target;
      if (!item || !item.classList || !item.classList.contains('wt-faq__item')) return;
      if (!item.open) return;
      closeSiblings(root, item);
    }, true);
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('.wt-faq');
    for (var i = 0; i < roots.length; i++) {
      bind(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    init(event.target);
  });
})();
